export default {"src":"/_next/static/media/white-play-icon.d5b619ee.svg","height":70,"width":58,"blurWidth":0,"blurHeight":0};